export default "/_next/static/files/8cbf3b594745a0a3cd0195d188347a38.png";